<template>
  <div class="d-flex flex-column justify-content-center align-items-center">
    <div class="d-flex align-items-center mar-top50">
      <img src="https://image.xingqubaike.com:8443/minicard/ucenter/personcenter/login/logo.png" style="width:40px;height:40px" class="imgFit"/>
      <div class="mar-left10">
        <div class="fz14 font-weight-bold" style="color:#42B983">兴趣百科</div>
        <div class="fz12">找兴趣，上兴趣百科</div>
      </div>
    </div>
    <!-- <div class="fz20 mar-top60">微信登录</div> -->
    <div id="wxcode"></div>
    <!-- <a href="javascript:void(0)" target="_blank" class="mar-top50 fz16 font-weight-bold">帮助与反馈</a> -->
    <router-link tag="a"
       target="_blank"
       :to="{ name: 'helpPage' }">帮助与反馈</router-link>
  </div>


</template>

<!-- <script type='text/javascript' src="http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"></script> -->
<script>
import axios from "axios";

export default {
  name: 'circleManager',
  components:{

  },
  data () {
    return {
      list: [],//日记列表
      layerShow:false
    }
  },
  mounted(){//页面加载后，调用接口数据
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';
    document.body.appendChild(s);

    setTimeout(function() {
      //this.createWxQrcode();
      var obj = new WxLogin({
        self_redirect:true,
        id:"wxcode",
        appid: "wx25a2550d1c798ff5",
        scope: "snsapi_login",
        redirect_uri: encodeURI("https://www.xingqubaike.com/web/#/loginsuccess")
      });
    }, 500);

  },
  methods:{

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped>
  //@import "../../../static/css/firstPage.css"; //直接在需要对应的vue中使用es6进行引入
  a{text-decoration: none;margin-top:50px;font-size:24px;color:royalblue}

</style>



// WEBPACK FOOTER //
// src/pages/pc/circleManager.vue